import FengmapBaseControl from './FengmapBaseControl'
import FengmapBaseOverlay from './FengmapBaseOverlay'

export const VALID_SUB_COMPONENTS = [FengmapBaseControl, FengmapBaseOverlay]
